const initialState = {
  discussions: [],
  loading: false,
  error: null,
  discussionsNumber: 0,
};

const discussionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DISCUSSIONS_LOADING":
      return {
        ...state,
        loading: true,
      };
    case "GET_DISCUSSIONS_SUCCESS":
      return {
        ...state,
        discussions: action.payload.data,
        loading: false,
        discussionsNumber: action.payload.meta.pagination.total,
      };

    case "GET_DISCUSSIONS_FAILURE":
      return initialState;
    default:
      return state;
  }
};
export default discussionsReducer;
